import { STATUS } from "@/utils/constants";

import {
  RESET,
  SET_ACTIVE_USER,
  SET_DATES,
  SET_FROM_DATE,
  SET_IS_DOWNLOADING_TIMESHEET_STATUS,
  SET_IS_FETCHING_SUMMARY_STATUS,
  SET_IS_SUBMITTING_TIMESHEET_TO_ACCOUNTING_STATUS,
  SET_IS_UPDATING_TIMESHEET_STATUS,
  SET_MODAL_TYPE,
  SET_SELECTED_USER_IDS,
  SET_SUMMARY,
  SET_TIME_TRACKING_TYPE,
  SET_TO_DATE,
} from "./timesheets.actionTypes";

const initialState = {
  isFetchingSummaryStatus: STATUS.IDLE,
  summary: [],
  fromDate: null,
  toDate: null,
  dates: [],
  isUpdatingTimesheetStatus: {},
  isDownloadingTimesheetStatus: STATUS.IDLE,
  isSubmittingTimesheetToAccountingStatus: STATUS.IDLE,
  selectedUserIds: [],
  activeUser: null,
  modalType: "",
  timeTrackingType: "work",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SUMMARY: {
      return { ...state, summary: action.payload };
    }

    case SET_IS_FETCHING_SUMMARY_STATUS: {
      return { ...state, isFetchingSummaryStatus: action.payload };
    }

    case SET_FROM_DATE: {
      return { ...state, fromDate: action.payload };
    }

    case SET_TO_DATE: {
      return { ...state, toDate: action.payload };
    }

    case SET_DATES: {
      return { ...state, dates: action.payload };
    }

    case SET_IS_UPDATING_TIMESHEET_STATUS: {
      return {
        ...state,
        isUpdatingTimesheetStatus: { ...state.isUpdatingTimesheetStatus, ...action.payload },
      };
    }

    case SET_IS_DOWNLOADING_TIMESHEET_STATUS: {
      return { ...state, isDownloadingTimesheetStatus: action.payload };
    }

    case SET_IS_SUBMITTING_TIMESHEET_TO_ACCOUNTING_STATUS: {
      return { ...state, isSubmittingTimesheetToAccountingStatus: action.payload };
    }

    case SET_SELECTED_USER_IDS: {
      return { ...state, selectedUserIds: action.payload };
    }

    case SET_MODAL_TYPE: {
      return { ...state, modalType: action.payload };
    }

    case SET_ACTIVE_USER: {
      return { ...state, activeUser: action.payload };
    }

    case SET_TIME_TRACKING_TYPE: {
      return { ...state, timeTrackingType: action.payload };
    }

    case RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
